import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    heading: {
      textAlign: 'center',
      fontSize: '1.2rem !important',
    },
    searchContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
      background: '#FFFFFF',
      borderRadius: '8px',
      border: '1px solid rgba(111, 111, 111, 0.25)',
      padding: '0 0.5rem',
      '& input': {
        background: 'transparent',
        border: 'transparent',
        outline: 'none',
        fontFamily: 'inherit',
        fontSize: '1rem',
        width: '100%',
        padding: '0.6rem 0.5rem 0.5rem',
      },
    },
    templateContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '2rem',
      paddingBottom: '10px',
      maxHeight: '450px',
      overflow: 'auto',
      scrollbarWidth: 'none',

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    templateBox: {
      boxShadow: '0px 4px 4px 0px #00000040',
      border: '1px solid #96969680',
      borderRadius: '10px 10px 0px 0px',
      '& img': {
        width: '280px',
        height: '200px',
        objectFit: 'cover',
        borderRadius: 'inherit',
        borderBottom: '1px solid #96969680',
      },
    },
    templateImageBox: {
      position: 'relative',

      '&:hover': {
        '& #img-overlay': {
          opacity: 1,
        },
      },
    },
    templateOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: '95%',
      width: '100%',
      opacity: 0,
      transition: '0.5s ease',
      backgroundColor: 'rgba(0, 0, 0, 0.50)',
      borderRadius: 'inherit',
    },
    templateNameButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      width: '100%',
      paddingBottom: '8px',
      opacity: '0.5',
    },
    selectCont: {
      color: 'white',
      fontSize: '20px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',

      '& button': {
        borderRadius: '3px',
        background: '#6AC5AB',
        padding: '8px 2rem',
        color: '#fff',
      },
    },
    noTemplateCont: {
      minHeight: '250px',
      minWidth: 'calc(560px + 2rem)',
      display: 'grid',
      placeItems: 'center',
    },
    skipButton: {
      backgroundColor: '#0069AA',
      width: '100%',

      '& p': {
        lineHeight: 1.7,
        color: '#fff',
        padding: '0.5rem 0',
      },
    },
    inputFields: {
      borderRadius: '8px',
      border: '1px solid rgba(111, 111, 111, 0.25)',
      background: '#FFF',
      boxShadow: '0px 4px 4px 0px #00000040 inset',
      fontSize: '1rem',
      padding: '0.6rem 1rem 0.5rem',
      minWidth: '440px',
      outline: 'none',
      fontFamily: 'inherit',
    },
    createSelect: {
      color: 'white',
      fontSize: '20px',
      display: 'flex',
      justifyContent: 'center',

      '& button': {
        borderRadius: '3px',
        background: '#6AC5AB',
        padding: '8px 2rem',
        color: '#fff',

        '&:disabled': {
          background: 'rgb(162, 167, 174)',
          cursor: 'not-allowed',
        },
      },
    },
    createContentCont: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      margin: '0 1rem',
    },
    createBackButton: {
      position: 'absolute',
      left: 0,
      top: '3px',
    },
    createTemplateCont: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    createTemplateBox: {
      boxShadow: '0px 4px 4px 0px #00000040',
      border: '1px solid #96969680',
      borderRadius: '10px 10px 0px 0px',
    },
    createImageCont: {
      width: '300px',
      height: '250px',

      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '10px 10px 0px 0px',
        borderBottom: '1px solid #96969680',
      },
    },
  })
);

export default useStyles;
